import * as React from 'react';
import { VtxButton, VtxIcon, VtxModal } from '@vertexinc/vtx-ui-react-component-library';
import Logging from '../Logging/Logging';
import RejectionDetailModalProps from './RejectionDetailModalProps.interface';
import './rejection-detail-modal.scss';
import {
  certificateUuidMarker,
  editTokenMarker,
  formatDate,
  settingRejectionLetterUrl,
  SettingsContextObject,
  stringToDate,
} from '../..';

const bodyStyle = {
  backgroundColor: 'white',
};

const RejectionDetailModal = ({
  isOpen,
  certificate,
  onOK,
  token,
}: RejectionDetailModalProps): JSX.Element => {
  const { settingsContext, setSettingsContext } = React.useContext(SettingsContextObject);

  const renderReasons = (): JSX.Element[] => {
    Logging.Debug('Rejection Reasons:', certificate?.status?.reasons);

    // eslint-disable-next-line arrow-body-style
    return certificate?.status?.reasons.map((reason: string) => {
      return (
        <li key={reason}>{reason}</li>
      );
    });
  };

  const getUrl = (): string => {
    const rejectionUrlSetting = `${settingRejectionLetterUrl}1`;

    let url = certificate.seller?.url
      ? certificate.seller.url
      : (settingsContext && settingsContext.certificates) ? settingsContext.certificates[rejectionUrlSetting] : null;

    if (url) {
      url = url.replace(certificateUuidMarker, token.uuid);
      url = url.replace(editTokenMarker, token.token);

      Logging.Info('Rejection Url', url);
    }

    return url;
  };

  if (!isOpen) {
    return (<></>);
  }

  return (
    <div>
      <VtxModal
        visible={isOpen}
        onCancel={(): void => onOK()}
        width="600px"
        bodyStyle={bodyStyle}
        footer={null}
        closable={false}
      >
        <div className="rejectionContainer">
          <div className="rejectionContainerLeft">
            <VtxIcon type="info-circle" fontSize={24} />
          </div>
          <div className="rejectionContainerRight">
            <div className="rejectionHeading">
              Rejected
            </div>
            <div className="rejectionLineNormal">
              {/* eslint-disable-next-line max-len */}
              {`This certificate was rejected on ${formatDate(stringToDate(certificate.status?.statusUpdateDateTime || certificate.lastUpdatedDateTime))}.`}
            </div>
            <div className="rejectionLineBold">
              Rejection Reasons:
            </div>
            <div className="rejectionLineNormal">
              <ul>
                {renderReasons()}
              </ul>
            </div>
            <div className="rejectionLineBold">
              Additional Information:
            </div>
            <div className="rejectionLineNormal">
              {certificate.status.additionalInfo || 'None'}
            </div>
            <div className="rejectionLineBold">
              Rejection URL:
            </div>
            <div className="rejectionLineNormal">
              {getUrl()}
            </div>
            <div className="confirmationButtons">
              <div className="buttonItemBase">
                <VtxButton
                  id="okButton"
                  onClick={onOK}
                  type="primary"
                >
                  OK
                </VtxButton>
              </div>
            </div>
          </div>
        </div>
      </VtxModal>
    </div>
  );
};

export default RejectionDetailModal;
